export default __webpack_public_path__ + "static/media/home-woman-with-phone.063871ab.png";